import { Component } from '@angular/core';
import { UserListsColumnComponent } from './user-lists-column.component';

@Component({
  template: `
    <div class="user-list-date-column">
      <span>{{ element.lastModified | glxyDate }}</span>
    </div>
  `,
  styleUrls: ['../user-lists-overview.component.scss'],
  standalone: false,
})
export class UserListDateColumnComponent extends UserListsColumnComponent {
  constructor() {
    super();
  }
}
